// extracted by mini-css-extract-plugin
export var image = "_i9-0";